import { render, staticRenderFns } from "./AccessError.vue?vue&type=template&id=08d5c986"
import script from "./AccessError.vue?vue&type=script&lang=js"
export * from "./AccessError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports